import React from 'react';
import './mobiledetect.scss';

const breakpoints = ['sm', 'md', 'lg'];

const isBreakpoint = (breakpoint) => {
  const beacon = document.getElementById(`js-${breakpoint}-beacon`);
  if (beacon) {
    return beacon.offsetWidth > 0;
  }
  return false;
};

const getBreakpoint = () => {
  for (let i = 0; i < breakpoints.length; i++) {
    if (isBreakpoint(breakpoints[i])) {
      return breakpoints[i];
    }
  }
  return 'base';
};

const MobileDetect = () => {
  return (
    <div>
      <div className="visible--only-sm" id="js-sm-beacon"></div>
      <div className="visible--only-md" id="js-md-beacon"></div>
      <div className="visible--only-lg" id="js-lg-beacon"></div>
    </div>
  );
};

MobileDetect.defaultProps = {
  getBreakpoint,
};

export default MobileDetect;
